import { Sector } from '@react/models/sector';
import { icbSectors } from 'skyeye-common-const/dist/reference/icbSectors';

export type Order = 'asc' | 'desc' | false;

export const ORDER = {
  asc: 'asc',
  desc: 'desc',
  false: false
};
export const NULL_STRING = 'NULL';
export const SEARCH_CONDITION = {
  OR: ' OR ',
  OR_SYMBOL: ' | ',
  AND: ' AND ',
  AND_SYMBOL: ' + ',
};

export const ACCOUNT_STATUS = {
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  WRONG_CREDENTIALS: 'WRONG_CREDENTIALS',
  CHANGED_SUCCESS: 'CHANGED_SUCCESS',
  CHANGED_FAIL: 'CHANGED_FAIL'
};

export const ACCOUNT_INFO = {
  SET_INFO: 'SET_INFO',
  GET_PROFILE: 'GET_PROFILE'
}

export const STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  WAITING: 'WAITING'
};

export const OPERATION = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  GET: 'GET',
  LIST: 'LIST',
  RETRIEVE: 'RETRIEVE',
  TRAINING: 'TRAINING',
  GRADUATE: 'GRADUATE',
  RULE: 'RULE',
  KEYDEV_CHECK_UPDATING_STATUS: 'KEYDEV_CHECK_UPDATING_STATUS'
};

export const KEY_DEV = {
  LIST: 'LIST',
  UPDATE: 'UPDATE',
};

export const ERROR_CODE = {
  NO_ACCESS: '401',
  NOT_FOUND: '404'
};

export const APIMFeatureCode = 'APIM';

export const SUBSCRIPTION_PLAN = {
  HideFeatureCodes: [APIMFeatureCode],
  SUB_TYPE_PERSONAL: 'PERSONAL',
  SUB_TYPE_ORG: 'ORGANISATION',
  SUB_DURATION: {
    DAY: 'DAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
    UNLIMITED: 'UNLIMITED',
  }
};

export const DURATION = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  UNLIMITED: 'UNLIMITED',
};

export const DURATION_IN_DAY = {
  DAY: 1,
  WEEK: 7,
  MONTH: 30,
  YEAR: 365,
};

export const SAVED_SEARCH_TYPE = {
  ARTICLE: 'ARTICLE',
  ORG: 'ORGANISATION',
  SCOUT_AI: 'SCOUT_AI',
  PEOPLE: 'PEOPLE',
};

export const ENTITY_TYPE = {
  ARTICLE: 'ARTICLE'
};


export const SCOUT_AI_TYPE = {
  CUSTOM: 'CUSTOM',
  STANDARD: 'STANDARD',
  ICBSECTOR: 'ICBSECTOR'
};

export const NEW_SCOUT_AI_TYPE = {
  STANDARD: 'STANDARD',
  CUSTOM: 'CUSTOM',
};

export const SUB_TYPE = {
  ORGANISATION: 'ORGANISATION',
  PERSONAL: 'PERSONAL',
  API: 'API'
};

export const SELECT_SUB_TYPE = {
  ORGANISATION: 'Organisation',
  USER: 'User'
}

export const SCOUT_AI_STATUS_LOWER_CASE = {
  COMPLETE: 'complete',
  GRADUATE: 'graduate',
};

export const SCOUT_AI_STATUS = {
  ALL: 'ALL',
  INITIAL: 'INITIAL',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  GRADUATED: 'GRADUATED',
};

export const SCOUT_AI_RELEVANT = {
  RELEVANT: 1,
  NON_RELEVANT: -1,
  NEUTRAL: 0
};

export const ARTICLE_PUBLISHER = {
  SGX: 'SGX',
  HKEX: 'HKEX',
  EMIS: 'EMIS',
  NAVIGA: 'Naviga',
  BUSINESS_WIRE: 'BusinessWire',
  BUSINESS_TIMES: 'TheBusinessTimes',
  STRAITS_TIMES: 'TheStraitsTimes',
  THE_NIKKEI: 'TheNikkei',
  SCRIPTS_ASIA: 'ScriptsAsia',
};

export enum Type {
  NUMBER = 'number',
  TEXT = 'text',
  BOOLEAN = 'boolean'
}

export enum USER_VALID_STATUS{
  INVALID,
  PUBLIC_USER,
  VALID
}

export const SITE_PARAMS = {
  ADD: 'add'
};

export const TRUE = true;
export const FALSE = false;
export const ZERO = 0;
export const EMPTY_STRING = '';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const NOT_AVAILABLE ='NA';
export const NONE ='None';
export const INACTIVE = 'Inactive';
export const ACTIVE = 'Active';
export const DASH = '-';
export const NO_RESULT = 'No Results Found';
export const RESULT_PER_PAGE = 20;
export const YEARS_FROM_NOW = 3;

export const initialReq = {
  select: RESULT_PER_PAGE,
  skip: 0,
};

export const DEFAULT_INTERNAL_ID_SEARCH_OPTION = 'keydev';
export const DEFAULT_TIMEZONE = '8';

export const SVC_TYPE = {
  ACCOUNT: 'ACCOUNT',
  CAMPAIGN: 'CAMPAIGN',
  CAMPAIGN_EVENT_USER: 'CAMPAIGN_EVENT_USER',
  CAMPAIGN_USER: 'CAMPAIGN_USER',
  LICENSE: 'LICENSE',
  ORGANISATION: 'ORGANISATION',
  RBAC: 'RBAC',
  SCOUT_AI: 'SCOUT_AI',
  SCOUT_AI_RESULT: 'SCOUT_AI_RESULT',
  SHARE_SCOUT_AI: 'SHARE_SCOUT_AI',
  SUBSCRIPTION: 'SUBSCRIPTION',
  SUBSCRIPTION_PLAN: 'SUBSCRIPTION_PLAN',
  USER: 'USER',
  SAVED_SEARCH: 'SAVED_SEARCH',
  TARGET_LIST: 'TARGET_LIST',
  SUB_ASSIGNEE: 'SUB_ASSIGNEE',
  KEY_DEV: 'KEY_DEV',
  KEY_DEV_REQUEST_LOG: 'KEY_DEV_REQUEST_LOG',
  KEY_DEV_REPORT: 'KEY_DEV_REPORT',
};

export const LOCKED = 'LOCKED';

export const LOCAL_STORAGE = {
  SIDE_BAR_ITEM_OPENED: 'SIDE_BAR_ITEM_OPENED',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  USER_INFO: 'USER_INFO',
};

export const SESSION_STORAGE = {
  REDIRECT_URL: 'PORTAL_REDIRECT_URL',
  KEYDEV_PERSISTED_FILTER: 'KEYDEV_PERSISTED_FILTER',
  OIDC_USER: 'OIDC_USER',
};

export const OTP_STATUS = {
  INIT_REQUEST: 'INIT_REQUEST',
  INIT_APPROVED: 'INIT_APPROVED',
  INIT_NOT_APPROVED: 'INIT_NOT_APPROVED',
  REQUEST: 'REQUEST',
  APPROVED: 'APPROVED'
};

export const OIDC = {
  CONFIGURATION: {
    HTML_ID: 'skyeye',
  },
  REDIRECT_URI: '/callback',
  SILENT_REDIRECT_URI: '/silent'
};

export function getSectors() : Array<Sector> {
  return icbSectors.filter((s) => s.display.length >= 1);
}

export const UNDEFINED_YEAR_FOUNDED = 'SCOUTASIA_SOURCE_UNDEFINED';

export const DRAWER_KEY_COMPANY_SUFFIX = 'filter-menu-';

export const DRAWER_KEY = {
  COMPANY: {
    SECTORS: `${DRAWER_KEY_COMPANY_SUFFIX}sectors`,
    BUSINESS_LINES: `${DRAWER_KEY_COMPANY_SUFFIX}business-lines`,
  },
};

export const COMPANY = {
  LISTING: {
    STATUS: {
      LISTED: 'LISTED',
      UNLISTED: 'UNLISTED'
    },
    WORDING: {
      LISTED: 'Listed',
      UNLISTED: 'Private'
    },
  },
  NAME: {
    TYPE: {
      ALIAS: 'alias',
      CURRENT: 'current',
      LOCAL: 'local',
      TRADE: 'trade',
      PREVIOUS: 'previous',
      LEGAL: 'legal',
      SHORT: 'short',
    }
  },
  STATUS: {
    ACTIVE: 'ACTIVE',
    UNKNOWN: 'UNKNOWN',
    BVD: {
      ACTIVE: 'Active',
      BANKRUPTCY: 'Bankruptcy',
      DISSOLVED_BANKRUPTCY: 'Dissolved (bankruptcy)',
      DEFAULT_OF_PAYMENT: 'Active (default of payment)',
      DISSOLVED: 'Dissolved',
      DORMANT: 'Active (dormant)',
      IN_LIQUIDATION: 'In liquidation',
      INSOLVENCY_PROCEEDINGS: 'Active (insolvency proceedings)',
      DISSOLVED_LIQUIDATION: 'Dissolved (liquidation)',
      MERGER_OR_TAKEOVER: 'Dissolved (merger or take-over)',
      REORGANISATION: 'Active (reorganization)',
      UNKNOWN: 'Unknown'
    },
    FWP: {
      ACTIVE: 'Active',
      DISSOLVED: 'Dissolved',
      TERMINATED: 'Terminated',
      UNKNOWN: 'Unknown'
    },
    CTOS: {
      ACTIVE: 'Active',
    },
    FACTSET: {
      ACTIVE: 'Active'
    },
    CREDITSAFE: {
      ACTIVE: 'Active'
    },
    FIINGROUP: {
      ACTIVE: 'Active',
      UNKNOWN: 'Unknown'
    },
    VENTUREINTELLIGENCE: {
      UNKNOWN: 'Unknown'
    },
    SCOUTASIA: {
      ACTIVE: 'Active',
    }
  },
  SOURCE: {
    FINANCIAL_TIMES: {
      LONG: 'Financial Times',
      SHORT: 'FT',
    },
    FACTSET: 'FACTSET',
    BVD: 'BVD',
    FIINGROUP: 'FIINGROUP',
    VI: 'VENTUREINTELLIGENCE',
    CREDITSAFE: 'CREDITSAFE',
    FWP: 'FWP',
    SCOUTASIA: 'SCOUTASIA',
  }
};

export const translateSpecialCharacters = (str: string) => {
  const pattern = /[-[\]{}()*+?.,\\^$|#\s]/g;
  return str.replace(pattern, (match => `\\${match}`));
};

export enum PEOPLE_SOURCE_TYPE {
  FACTSET = 'FACTSET',
  SCOUTASIA = 'SCOUTASIA',
}

export interface ICompanyPeople { 
  source: PEOPLE_SOURCE_TYPE,
  officers: ICompanyOfficer[]
}

export interface ICompanyOfficer {
  type: string;
  id: string;
  name: string;
}

export const SUB_PLAN_FEATURE_DEFAULT_VALUE = {
  APIM_MAX_ENTITY_COUNT: 100,
  RADAR_ARTICLE_SEARCH_CRITERIA_COUNT: 3,
};

export const SUB_PLAN_FEATURE_MIN_VALUE = {
  RADAR_ARTICLE_SEARCH_CRITERIA_COUNT: 3,
};

export const SUB_PLAN_FEATURE_MAX_VALUE = {
  RADAR_ARTICLE_SEARCH_CRITERIA_COUNT: 20,
};

export enum SUB_PLAN_FEATURE_CODE {
  RADAR_COUNT = 'RADAR_COUNT',
  RADAR_ARTICLE_SEARCH_CRITERIA_COUNT = 'RADAR_ARTICLE_SEARCH_CRITERIA_COUNT'
}

export const SwaggerDocEnvironmentMap = {
  localhost: 'developer-',
  'developer-portal': 'developer-',
  'staging-portal': 'staging-',
  'feature-portal': 'feature-',
  portal: EMPTY_STRING
}

export const REDIRECT_URL_PUBLIC: {
  [key: string]: string;
} = {
  'http://localhost:4901': 'https://developer.scout.asia',
  'https://developer-portal.scout.asia': 'https://developer.scout.asia',
  'https://staging-portal.scout.asia': 'https://staging.scout.asia',
  'https://feature-portal.scout.asia': 'https://feature.scout.asia',
  'https://beta-portal.scout.asia': 'https://beta.scout.asia',
  'https://portal.scout.asia': 'https://app.scout.asia',
};

export const OVERALL_STATUS_COLOR: {
  [key: string]: string;
} = {
  Successful: '#139C67',
  'In Progress': '#DB7425',
  Failed: '#CF152A', 
};

export const OVERALL_STATUS_SUBMIT: {
  [label: string]: string[];
} = {
  successful: ['COMPLETE'],
  processing: ['SUBMIT'],
  failed: ['MLPFAIL', 'DPPFAIL'],
};
